const fieldBorderValidation = {
  errorPlacement() {
    return true;
  },
  highlight(element) {
    const $el = $(element);
    $el.addClass('error').removeClass('valid');
    $el.closest('div[class^="form-holder"]').addClass('has-error').removeClass('accept');
  },
  unhighlight(element) {
    const $el = $(element);
    $el.removeClass('error').addClass('valid');
    $el.closest('div[class^="form-holder"]').removeClass('has-error').addClass('accept');
  },
};

export const subscribeForm = () => {
  $('.subscribe-mail .ft-form').validate({
    submitHandler: function (form) {
      $('.subscribe-mail.subscribe-block').addClass('active');

      setTimeout(function () {
        $('.subscribe-mail.subscribe-block form').hide();
        $('.subscribe-mail.subscribe-block')
          .html(
            `
          <div class="subscribe__text">
            Subscription Confirmed!
            </div>
        `
          )
          .removeClass('active');
      }, 1000);
    },
    success: () => {},
    ...fieldBorderValidation,
    rules: {
      email: {
        required: true,
        email: true,
      },
    },
  });
  $('.subscribe-mail2 .ft-form').validate({
    submitHandler: function (form) {

      setTimeout(function () {
        $('.subscribe-mail2 form').hide();
        $('.subscribe-mail2')
          .html(
            `
          <div class="subscribe__text">
            Subscription Confirmed!
            </div>
        `
          )
          .removeClass('active');
      }, 1000);
    },
    success: () => {},
    ...fieldBorderValidation,
    rules: {
      email: {
        required: true,
        email: true,
      },
    },
  });
  $('.subscribe-phone .ft-form').validate({
    submitHandler: function (form) {
      $('.subscribe-phone.subscribe-block').addClass('active');

      setTimeout(function () {
        $('.subscribe-phone.subscribe-block form').hide();
        $('.subscribe-phone.subscribe-block')
          .html(
            `
          <div class="subscribe__text">
            Subscription Confirmed!
          </div>
        `
          )
          .removeClass('active');
      }, 1000);
    },
    success: () => {},
    ...fieldBorderValidation,
    rules: {
      phone: {
        required: true,
        digits: true,
        maxlength: 20,
      },
    },
  });
  $('.subscribe-phone .ft-form__input[name="phone"]')
  .attr('maxlength', 20)
  .on('keypress', function (e) {
    if (e.which < 48 || e.which > 57) { 
      e.preventDefault();
    }
  })
  .on('input', function () {
    if (this.value.length > 20) {
      this.value = this.value.slice(0, 20);
    }
  });

  $('.footer-cont-top form').validate({
    submitHandler: function (form) {
      $('.contact-form__result').html(`
          Thank you for your message. It has been sent.
      `);
      $('.footer-cont-top form *').hide();
      $('.contact-form__result').show();
    },
    success: () => {},
    ...fieldBorderValidation,
    rules: {
      email: {
        required: true,
        email: true,
      },
    },
  });

  $('.contact-form form').validate({
    submitHandler: function (form) {
      if (
        $('#contactCheck1').is(':checked') &&
        $('#contactCheck2').is(':checked') &&
        $('#contactCheck3').is(':checked') &&
        $('#contactCheck4').is(':checked')
      ) {
        $('.contact-form__result').html(`
              Thank you for your message. It has been sent.
          `);
      }
    },
    success: () => {},
    ...fieldBorderValidation,
    rules: {
      contactFirstName: {
        required: true,
      },
      contactLastName: {
        required: true,
      },
      contactPhone: {
        required: true,
      },
      contactEmail: {
        required: true,
        email: true,
      },
      contactSelect: {
        required: true,
      },
      contactMessage: {
        required: true,
      },
      contactCheck1: {
        required: true,
      },
      contactCheck2: {
        required: true,
      },
      contactCheck3: {
        required: true,
      },
      contactCheck4: {
        required: true,
      },
    },
  });

  $('.section7-ft-form').validate({
    submitHandler: function (form) {
      setTimeout(function () {
        $('.section7-ft-form')
          .html(
            `
          <div class="subscribe__text">
            Thank you for your message, we will contact you as soon as possible.
            </div>
        `
          )
          .removeClass('active');
      }, 1000);
    },
    success: () => {},
    ...fieldBorderValidation,
    rules: {
      name: {
        required: true,
      },
      company: {
        required: true,
      },
      email: {
        required: true,
        email: true,
      },
      phone: {
        required: true,
      },
      message: {
        required: true,
      },
    },
  });

  $('.contact-form form input[name="phone"]')
    .attr('maxlength', 20)
    .on('keypress', function (e) {
      if (e.which < 48 || e.which > 57) {
        e.preventDefault();
      }
    })
    .on('input', function () {
      if (this.value.length > 20) {
        this.value = this.value.slice(0, 20);
      }
    });



    
  const $form = $('#contactForm');
  if ($form.length) {
    $form.validate({
      onfocusout: false,

      rules: {
        name: { required: true, minlength: 2 },
        email: { required: true, email: true },
        subject: { required: true },
        message: { required: true },
      },
      messages: {
        name: 'Please enter your name',
      },

      highlight: function (element) {
        $(element).addClass('border-red-500 ring-1 ring-red-500').removeClass('border-gray-300 focus:ring-green-500');
      },

      unhighlight: function (element) {
        $(element).removeClass('border-red-500 ring-1 ring-red-500').addClass('border-gray-300 focus:ring-green-500');
      },

      errorPlacement: function (error, element) {
        return true;
      },

      submitHandler: function (form) {
        const $btn = $(form).find('button[type="submit"]');
        const originalText = $btn.text();

        $btn.prop('disabled', true).text('Sending...');

        setTimeout(function () {
          $(form).find('.form-holder, button').hide();

          $('.contact-form__result').removeClass('hidden').html(`
                            <div class="p-4 bg-green-50 text-green-700 rounded-lg border border-green-200 text-center">
                                <p class="font-bold text-lg">Thank you!</p>
                                <p>Your message has been sent successfully.</p>
                            </div>
                        `);
        }, 1000);
      },
    });
  }
};
